module.exports = __webpack_public_path__ + "37c452f4d7213db6bf89f88543a3e827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class/bg_head2.png
// module id = 275
// module chunks = 0